var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "operator-container" },
    [
      _c(
        "md-menu",
        {
          ref: "operatorMenu",
          attrs: { "md-direction": "bottom-start", "md-size": "auto" },
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-icon-button operator-trigger",
              attrs: { "md-menu-trigger": "" },
            },
            [
              _c("div", { staticClass: "operator-trigger__icon" }, [
                _vm._v(_vm._s(_vm.selectedOperator)),
              ]),
            ]
          ),
          _c(
            "md-menu-content",
            { staticClass: "operator-menu" },
            _vm._l(_vm.operatorOptions, function (option) {
              return _c(
                "md-menu-item",
                {
                  key: option.value,
                  class: {
                    "is-selected": option.value === _vm.selectedOperator,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection(option)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "operator-menu__icon" }, [
                    _vm._v(_vm._s(option.value)),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }